import http from "@/http";

// ###   获取岗位列表
//   http://base.leubao.com/api/post/list
export const getPostList = {
  p: "/api/post/list",
  r: data => {
    return http({
      url: "/api/post/list",
      method: "post",
      data
    });
  }
};
// ###   全部获取岗位列表
// http://base.leubao.com/api/post/all
export const getPostAll = {
  p: "/api/post/all",
  r: data => {
    return http({
      url: "/api/post/all",
      method: "get"
    });
  }
};
//###   获取岗位详细信息
// http://base.leubao.com/api/post/details/1
export const getPostInfo = {
  p: "/api/post/details",
  r: data => {
    return http({
      url: "/api/post/details/" + data.id,
      method: "get"
    });
  }
};
//###   添加岗位信息
// http://base.leubao.com/api/post/add
export const addPost = {
  p: "/api/post/add",
  r: data => {
    return http({
      url: "/api/post/add",
      method: "post",
      data
    });
  }
};
//###  修改岗位信息
// http://base.leubao.com/api/post/edit
export const editPost = {
  p: "/api/post/edit",
  r: data => {
    return http({
      url: "/api/post/edit",
      method: "post",
      data
    });
  }
};
// ###  删除岗位信息
//  http://base.leubao.com/api/post/delete
export const deletePost = {
  p: "/api/post/delete",
  r: data => {
    return http({
      url: "/api/post/delete",
      method: "post",
      data
    });
  }
};
